// extracted by mini-css-extract-plugin
export var bounceIn = "x_bQ";
export var column = "x_B";
export var loader = "x_bS";
export var scrollThumb = "x_bV";
export var scrollWrapper = "x_bW";
export var scrollbar = "x_bT";
export var scroller = "x_bX";
export var wordHelper = "x_bP";
export var wordHelper__modal = "x_bR";